import { FC } from 'react';
import Create from 'components/segments/components/Create';

const Screen: FC = () => {
  return <Create segmentsEntityName="segments" />;
};

export default Screen;
